// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./public/css/vendor/rzslider.css
// module id = PhDd
// module chunks = 1